function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 36.277344 31.507812 L 11.953125 31.507812 C 10.050781 31.507812 8.5 29.957031 8.5 28.050781 L 8.5 23.589844 C 8.5 23.226562 8.792969 22.929688 9.15625 22.929688 C 9.519531 22.929688 9.816406 23.226562 9.816406 23.589844 L 9.816406 28.050781 C 9.816406 29.230469 10.773438 30.1875 11.953125 30.1875 L 36.277344 30.1875 C 37.457031 30.1875 38.417969 29.230469 38.417969 28.050781 L 38.417969 11.90625 C 38.417969 10.726562 37.457031 9.765625 36.277344 9.765625 L 11.953125 9.765625 C 10.773438 9.765625 9.816406 10.726562 9.816406 11.90625 L 9.816406 16.3125 C 9.816406 16.675781 9.519531 16.972656 9.15625 16.972656 C 8.792969 16.972656 8.5 16.675781 8.5 16.3125 L 8.5 11.90625 C 8.5 10 10.050781 8.449219 11.953125 8.449219 L 36.277344 8.449219 C 38.183594 8.449219 39.734375 10 39.734375 11.90625 L 39.734375 28.050781 C 39.734375 29.957031 38.183594 31.507812 36.277344 31.507812 Z M 36.277344 31.507812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 28.203125 19.976562 L 35.546875 13.242188 C 35.8125 12.996094 35.832031 12.578125 35.585938 12.308594 C 35.339844 12.042969 34.925781 12.023438 34.65625 12.269531 L 24.117188 21.9375 L 13.578125 12.269531 C 13.308594 12.023438 12.894531 12.042969 12.648438 12.308594 C 12.402344 12.578125 12.417969 12.996094 12.6875 13.242188 L 20.03125 19.976562 L 12.6875 26.714844 C 12.417969 26.960938 12.402344 27.378906 12.648438 27.644531 C 12.777344 27.789062 12.953125 27.859375 13.132812 27.859375 C 13.292969 27.859375 13.453125 27.800781 13.578125 27.683594 L 21.003906 20.871094 L 23.671875 23.316406 C 23.796875 23.433594 23.957031 23.492188 24.117188 23.492188 C 24.277344 23.492188 24.4375 23.433594 24.5625 23.316406 L 27.226562 20.871094 L 34.65625 27.683594 C 34.78125 27.800781 34.941406 27.859375 35.101562 27.859375 C 35.277344 27.859375 35.457031 27.789062 35.585938 27.644531 C 35.832031 27.378906 35.8125 26.960938 35.546875 26.714844 Z M 28.203125 19.976562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.382812 20.636719 L 3.53125 20.636719 C 3.164062 20.636719 2.871094 20.339844 2.871094 19.976562 C 2.871094 19.613281 3.164062 19.320312 3.53125 19.320312 L 11.382812 19.320312 C 11.746094 19.320312 12.042969 19.613281 12.042969 19.976562 C 12.042969 20.339844 11.746094 20.636719 11.382812 20.636719 Z M 11.382812 20.636719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 5.707031 16.03125 L 0.878906 16.03125 C 0.515625 16.03125 0.21875 15.738281 0.21875 15.375 C 0.21875 15.011719 0.515625 14.714844 0.878906 14.714844 L 5.707031 14.714844 C 6.070312 14.714844 6.367188 15.011719 6.367188 15.375 C 6.367188 15.738281 6.070312 16.03125 5.707031 16.03125 Z M 5.707031 16.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 5.707031 25.238281 L 2.148438 25.238281 C 1.785156 25.238281 1.492188 24.945312 1.492188 24.582031 C 1.492188 24.21875 1.785156 23.921875 2.148438 23.921875 L 5.707031 23.921875 C 6.070312 23.921875 6.367188 24.21875 6.367188 24.582031 C 6.367188 24.945312 6.070312 25.238281 5.707031 25.238281 Z M 5.707031 25.238281 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail3);
export default __webpack_public_path__ + "static/media/mail3.4c7a9b7d.svg";
export { ForwardRef as ReactComponent };